import { render } from "./ConferencesSection.vue?vue&type=template&id=65cfa20b&scoped=true"
import script from "./ConferencesSection.vue?vue&type=script&lang=js"
export * from "./ConferencesSection.vue?vue&type=script&lang=js"

import "./ConferencesSection.vue?vue&type=style&index=0&id=65cfa20b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cfa20b"]])

export default __exports__